import Immutable from 'immutable';
import ErrorConstants from '../../constants/ErrorConstants';

const initialState = Immutable.Map({
  error: null,
  showErrorPage: false
});

export default function internalError(state = initialState, action) {
  switch (action.type) {
    case ErrorConstants.SHOW_ERROR_PAGE: {
      return state.set('showErrorPage', true);
    }

    case ErrorConstants.STORE_INTERNAL_ERROR: {
      return state.set('error', Immutable.fromJS(action.payload.error));
    }

    default:
      return state;
  }
}
